import { logger } from 'utils/logger';
class _AuthService {
    constructor() {
        this.state = null;
        this._user = null;
        this._guest = null;
        this._tokenUser = null;
        this._token = null;
        this.initialize();
        this.addLogoutEventListener();
    }

    initialize() {
        const authUserToken = this._getNullSafe('authUserToken');
        // As we remove the authUserToken from the local storage,
        // we need to cleanup from storage
        if (authUserToken) {
            this.logout();
        }

        const localUser = this._getNullSafe('user');
        this._user = localUser ? JSON.parse(localUser) : null;

        const localGuest = this._getNullSafe('guest');
        this._guest = localGuest ? JSON.parse(localGuest) : null;
    }

    addLogoutEventListener() {
        window.addEventListener('storage', (event) => {
            if (
                (this.token && this.tokenUser && this.tokenUser.id_seq) ||
                window.location.href.includes('embedded')
            ) {
                return;
            }
            if (['user'].includes(event.key) && event.newValue === null) {
                this.logout();
                window.location.href = '/';
            }
            if (['loggedInAt'].includes(event.key) && event.newValue === null) {
                window.location.href = '/';
            }
        });
    }

    isLogin(allowGuest = false) {
        if (this.token && this.tokenUser && this.tokenUser.id_seq) {
            return true;
        }

        /*
         * A user has `direct: true` if they are landing through a magic link
         * See: ../store/reducers/auth.js
         */
        //  if (this._user && this._user.direct) return true;

        const user =
            this._getNullSafe('user') ||
            (allowGuest ? this._getNullSafe('guest') : null);
        if (!!user) {
            const { id_seq } = JSON.parse(user) || {};
            if (id_seq) {
                return true;
            }
        }

        return false;
    }

    getCachedUser() {
        return (this.loggedInAt ? this.user : null) || this.guest;
    }

    listen(store) {
        //return () => (this.state = store.getState());
    }

    logout() {
        this.user = null;
        this.guest = null;
        // localStorage.clear();
        // clear the local storage except the feedback
        Object.entries(localStorage).forEach(([key]) => {
            if (
                key.indexOf('feedback-') >= 0 ||
                key.indexOf('pref_') >= 0 ||
                [
                    'cookieBanner',
                    'announcementBanner',
                    'productTourStat',
                    'meterAlerts',
                    'closeBannerClickedTime',
                    'intro-video-shown',
                ].includes(key)
            ) {
                return;
            }
            delete localStorage[key];
        });
        // End fullstory recording session for user
        if (window.FS) window.FS.anonymize();
    }

    set user(data = {}) {
        /*
         * This makes it possible for a user landing through a magic link
         * to be contained only in the app memory
         * A simple refresh is good enough to kick them out, unless they use
         * the same magic link to jump in again
         */

        // if (data && data.direct) {
        //     return (this._user = data);
        // }

        if (data !== this._user) {
            localStorage[
                data === null || typeof data === 'undefined'
                    ? 'removeItem'
                    : 'setItem'
            ]('user', JSON.stringify(data));
            this._user = data;
            // If we're setting a user, clear any existing guest information
            if (!!data && !!this.guest) {
                this.guest = null;
            }
        }
    }

    get user() {
        return this._tokenUser ? null : this._user;
    }

    set loggedInAt(loggedInAt) {
        return localStorage[
            loggedInAt === null || typeof loggedInAt === 'undefined'
                ? 'removeItem'
                : 'setItem'
        ]('loggedInAt', loggedInAt);
    }

    get loggedInAt() {
        return this._tokenUser ? null : this._getNullSafe('loggedInAt');
    }

    set guest(data) {
        if (data !== this._guest && (!data || !data.direct)) {
            localStorage[
                data === null || typeof data === 'undefined'
                    ? 'removeItem'
                    : 'setItem'
            ]('guest', JSON.stringify(data));
            this._guest = data;
        }
        this._guest = data;
    }

    get guest() {
        return this._tokenUser ? null : this._guest;
    }

    setTokenUser(tokenUser, token) {
        this._tokenUser = tokenUser;
        this._token = token;
    }

    get tokenUser() {
        return this._tokenUser;
    }

    get token() {
        return this._token;
    }

    _getNullSafe(key) {
        try {
            const val = localStorage.getItem(key);

            return val === 'null' ? null : val;
        } catch {
            logger.info('localStorage is disabled');
        }
    }
}

const AuthService = new _AuthService();
export default AuthService;
